module.exports = __webpack_public_path__ + "img/area_17.7aaccfe0.svg";